import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import PieceJointeService from '../../services/PieceJointesServices';

const initialState = {
  PieceJointes: [],
  PieceJointeId: {},
  pageSize: 20,
  currentPage: 1,
  totalElements: 0,
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: '',
};

export const createPieceJointe = createAsyncThunk(
  'PieceJointe/create',
  async ({id,data}, thunkAPI) => {
    try {
      return await PieceJointeService.createPiece(id,data);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllPieceJointe = createAsyncThunk(
  'PieceJointe/getAll',
  async (_, thunkAPI) => {
    try {
      return await PieceJointeService.getAll();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deletePieceJointe = createAsyncThunk(
  'PieceJointe/delete',
  async (id, thunkAPI) => {
    try {
      return await PieceJointeService.deletePiece(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const PieceJointeSlice = createSlice({
  name: 'piecejointes',
  initialState,
  reducers: {
    clearPieceJointe: state => initialState,
  },
  extraReducers: builder => {
    builder
      .addCase(createPieceJointe.pending, state => {
        state.isLoading = true;
      })
      .addCase(createPieceJointe.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const created = action.payload?.result || action.payload?.data || action.payload;
        if (created) {
          state.PieceJointes.unshift(created);
        }
      })
      .addCase(createPieceJointe.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(getAllPieceJointe.pending, state => {
        state.isLoading = true;
      })
      .addCase(getAllPieceJointe.fulfilled, (state, action) => {
        state.isLoading = false;
        const payload = action.payload?.result || action.payload?.data || action.payload;
        const items = Array.isArray(payload) ? payload : payload?.items || payload?.data || [];
        state.PieceJointes = items;
        const pagination = action.payload?.pagination || {};
        state.currentPage = pagination.current_page || 1;
        state.pageSize = pagination.limit || items.length || 20;
        state.totalElements = pagination.total_items || items.length || 0;
      })
      .addCase(getAllPieceJointe.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(deletePieceJointe.pending, state => {
        state.isLoading = true;
      })
      .addCase(deletePieceJointe.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        const deletedId = action.payload?.data ?? action.payload?.id;
        state.PieceJointes = state.PieceJointes.filter(goal => goal.id !== deletedId);
      })
      .addCase(deletePieceJointe.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      });
  },
});

export const { clearPieceJointe } = PieceJointeSlice.actions;
export default PieceJointeSlice.reducer;
